import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useSEO } from "../hooks/useSEO";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND}/api`;

const PaymentSuccess = () => {
  useSEO(
    "Payment Confirmed — Download | Mortgage Survival Playbook 2026",
    "Your payment is confirmed. Download your Mortgage Survival Playbook 2026 institutional license package securely.",
    { noindex: true }
  );
  const navigate = useNavigate();
  const [state, setState] = useState("checking"); // checking | ready | error
  const [token, setToken] = useState("");

  useEffect(() => {
    const sessionId = new URLSearchParams(window.location.search).get("session_id");
    if (!sessionId) { setState("error"); return; }
    let tries = 0;
    let timer;
    const poll = async () => {
      tries += 1;
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        if (data.payment_status === "paid" && data.download_token) {
          setToken(data.download_token);
          setState("ready");
          return;
        }
      } catch (e) { /* keep polling */ }
      if (tries >= 30) { setState("error"); return; }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, []);

  const download = () => { window.location.href = `${API}/download/${token}`; };

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: "2rem" }} data-testid="payment-success-page">
      <div className="hero-bg" />
      <div style={{ maxWidth: 560, textAlign: "center", position: "relative" }}>
        {state === "checking" && (
          <>
            <h1 className="article-title" data-testid="success-checking">Confirming your payment…</h1>
            <p style={{ color: "var(--g1)" }}>Please wait a moment — do not close this page.</p>
          </>
        )}
        {state === "ready" && (
          <>
            <div className="eyebrow">Payment Complete</div>
            <h1 className="article-title">Thank you — your license is ready</h1>
            <p style={{ color: "var(--g1)", lineHeight: 1.8, marginBottom: "1.5rem" }}>
              Your payment was received. This is your <strong>one-time secure download</strong> — please save the file somewhere safe, as the link can be used once.
            </p>
            <button className="btn-gold" onClick={download} data-testid="success-download-btn" style={{ height: 52, fontSize: "1rem", padding: "0 2rem" }}>
              Download the Playbook (ZIP)
            </button>
            <p style={{ color: "var(--g3)", fontSize: "0.8rem", marginTop: "1.5rem" }}>
              Trouble downloading? Email <a href="mailto:hello@mortgagesurvivalplaybook.com" style={{ color: "var(--gold)" }}>hello@mortgagesurvivalplaybook.com</a>
            </p>
          </>
        )}
        {state === "error" && (
          <>
            <h1 className="article-title" data-testid="success-error">We couldn't confirm your payment yet</h1>
            <p style={{ color: "var(--g1)", lineHeight: 1.8 }}>
              If you were charged, your download link is safe — email <a href="mailto:hello@mortgagesurvivalplaybook.com" style={{ color: "var(--gold)" }}>hello@mortgagesurvivalplaybook.com</a> and we'll send it right away.
            </p>
            <button className="btn-gold" onClick={() => navigate("/")} style={{ marginTop: "1.5rem" }}>Return Home</button>
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentSuccess;
